<template>
    <div class="min-h-screen flex flex-col">
        <div class="container mx-auto p-2 mt-8">
            <div class="max-w-sm w-full mx-auto bg-white px-5 py-10 shadow-md rounded-lg">
                <img src="../../assets/logo.png" class="pr-6 pb-6 mx-auto w-64">

                <form @submit.prevent="submit">
                    <label class="block text-xs font-semibold text-gray-500 mb-1">Email</label>
                    <input
                        v-model="email"
                        type="email"
                        placeholder="admin@email.com"
                        class="input input-bordered w-full text-sm mb-4"
                        :disabled="step === 'totp' || loading"
                    />

                    <div v-if="step === 'totp'" class="mb-4">
                        <label class="block text-xs font-semibold text-gray-500 mb-1">Código TOTP (6 dígitos)</label>
                        <input
                            ref="totpInput"
                            v-model="totpCode"
                            type="text"
                            inputmode="numeric"
                            maxlength="6"
                            placeholder="000000"
                            class="input input-bordered w-full text-sm text-center tracking-widest font-mono"
                        />
                        <p class="text-xs text-gray-400 mt-1">Abra o Google Authenticator e insira o código.</p>
                    </div>

                    <p v-if="error" class="text-red-600 text-xs mb-3 text-center">{{ error }}</p>

                    <button type="submit" class="w-full btn btn-primary text-white" :disabled="loading">
                        <span v-if="loading" class="loading loading-spinner loading-sm"></span>
                        <span v-else-if="step === 'email'">Continuar</span>
                        <span v-else>Entrar</span>
                    </button>

                    <button
                        v-if="step === 'totp'"
                        type="button"
                        @click="resetStep"
                        class="w-full mt-2 text-xs text-gray-400 hover:text-gray-600 transition-colors"
                    >
                        Trocar email
                    </button>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import { ref, nextTick } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import AdminAuthService from '@/services/admin/AdminAuthService';

export default {
    name: 'AdminLogin',
    setup() {
        const router = useRouter();
        const route = useRoute();
        const email = ref('');
        const totpCode = ref('');
        const step = ref('email');
        const loading = ref(false);
        const error = ref('');
        const totpInput = ref(null);

        async function submit() {
            error.value = '';
            if (!email.value) return;

            loading.value = true;
            try {
                if (step.value === 'email') {
                    const { data } = await AdminAuthService.init(email.value);
                    if (data.needsSetup) {
                        router.push({ name: 'adminSetup', params: { uuid: route.params.uuid }, query: { email: email.value } });
                    } else {
                        step.value = 'totp';
                        await nextTick();
                        totpInput.value?.focus();
                    }
                } else {
                    if (totpCode.value.length !== 6) {
                        error.value = 'Código deve ter 6 dígitos';
                        return;
                    }
                    const { data } = await AdminAuthService.login(email.value, totpCode.value);
                    AdminAuthService.saveToken(data.token);
                    router.push({ name: 'adminDashboard', params: { uuid: route.params.uuid } });
                }
            } catch (err) {
                error.value = err.response?.data?.text || 'Erro ao autenticar';
                totpCode.value = '';
            } finally {
                loading.value = false;
            }
        }

        function resetStep() {
            step.value = 'email';
            totpCode.value = '';
            error.value = '';
        }

        return { email, totpCode, step, loading, error, totpInput, submit, resetStep };
    }
};
</script>
